import { type UserContext } from '../bubble/store/buildUserContext';

/**
 * Minimal `UserContext` for pre-auth onboarding dictation.
 *
 * No Heidi user exists yet, so there is nothing to personalise the last-chunk
 * post-processing with. We send safe defaults — English input, no word library,
 * empty clinician identity — so the transcription service can still run inline
 * post-processing without a user profile. Mirrors the shape produced by
 * {@link buildUserContext} so the Rust pass-through and t11n contract stay
 * identical between the anonymous and authenticated paths.
 */
export function buildOnboardingUserContext(): UserContext {
  return {
    date_format: 'DD/MM/YYYY',
    spelling_preference: '',
    word_library: null,
    input_languages: ['en'],
    clinician_title: '',
    clinician_firstname: '',
    clinician_surname: '',
  };
}
